import parserLanguages from './parsers/languages.json';

let config = Object.keys(process.env).reduce((obj, item) => {
    return {
        ...obj,
        [item.replace(/^VUE_APP_/g, '')]: process.env[item],
    };
}, {});

config.AVAILABLE_LANGS = require
    .context('./translations', true, /^.*.json$/)
    .keys()
    .map((trans) => trans.substr(2, 2))
    .reduce((obj, lang) => {
        return {
            ...obj,
            [lang]: parserLanguages[lang],
        };
    }, {});

if (!config.AVAILABLE_LANGS[config.DEFAULT_LANG]) config.DEFAULT_LANG = Object.keys(config.AVAILABLE_LANGS)[0];

export default config;
